<template>
  <div>
    <!--    <AddThis-->
    <!--      publicId="ra-59032d4284ae854f"-->
    <!--      :data-url="outfitter.facebook"-->
    <!--      :data-title="'Rafting With ' + outfitter.name"-->
    <!--    />-->
    <common-nav :show-cart="false" :show-new-order="true"></common-nav>
    <router-view></router-view>
  </div>
</template>

<script>
import CommonNav from "@/components/ui/nav/CommonNav";
// import AddThis from "vue-simple-addthis-share";

export default {
  name: "Deliver",
  components: {
    CommonNav,
    // AddThis,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    outfitter: function () {
      return this.$store.getters["search/getOutfitter"];
    },
  },
  mounted() {
    this.$store.dispatch("search/get_outfitter", this.$route.params.slug);
  },
};
</script>
